/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';
import useRouter from 'js/lib/useRouter';

import { Grid, Typography2 } from '@coursera/cds-core';

import { getSettingsLink } from 'bundles/enterprise-admin-navigation';
import { truncate } from 'bundles/enterprise-ui';
import { TrackedReactLink } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/enterprise-admin-home';

type Props = {
  orgName: string;
};

const LandingPageUploadLogo: React.FC<Props> = ({ orgName }) => {
  const router = useRouter();

  const handleNavigateToSettings = () => {
    const { params } = router;
    return getSettingsLink(params);
  };

  return (
    <Grid css={{ marginTop: 'var(--cds-spacing-200)' }} container justifyContent="center">
      <Typography2 component="p" variant="bodyPrimary">
        <FormattedMessage
          message={_t(
            `You can upload a custom logo to help your team
recognize Coursera for {fullName}. `
          )}
          fullName={truncate(orgName, 20)}
        />
        <TrackedReactLink href={handleNavigateToSettings()} trackingName="admin_landing_page_upload_logo">
          {_t('Upload logo')}
        </TrackedReactLink>
      </Typography2>
    </Grid>
  );
};

export default LandingPageUploadLogo;
